import { timeFormat, select } from "d3";
import { finitNum } from "@/_core/_helpers/_helpers";
import { saveUserPreferences } from "@/_core/data/SaveToDB";

export function getUnits(idx, commSpecs) {
  return (
    (commSpecs[idx].is_cents ? "USc" : commSpecs[idx].fk_idcurrency) +
    "/" +
    commSpecs[idx].fk_idunit
  );
}

// ==== commodity: CPO Colombia
export function forwardsAverages(
  _this,
  firstContract,
  resultField,
  rawField,
  histField,
  isHalfMonth = false
) {
  const date = new Date();
  let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
  let currentDate = _this[histField][_this[histField].length - 1].date;
  let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  let middleDay, nDates, nDates2, aveKnown;
  aveKnown = _this[histField]
    .filter(d => d.date >= firstDay)
    .map(d => (isFinite(d.settle) && d.settle != null ? d.settle : d.close));
  if (currentDate.getDate() < 15 && isHalfMonth) {
    middleDay = new Date(date.getFullYear(), date.getMonth(), 15);
    nDates = _this.processData.createWorkingDays(middleDay, lastDay).length;
    nDates2 = _this.processData.createWorkingDays(currentDate, middleDay)
      .length;
    firstContract += 1;
  } else {
    nDates = _this.processData.createWorkingDays(currentDate, lastDay).length;
    nDates2 = 0;
  }
  _this[resultField] = [];
  let aveAux;
  _this[rawField].forEach(function(d, i) {
    d.close = isFinite(d.settle) && d.settle != null ? d.settle : d.close;
    if (d.continuous_contract === firstContract) {
      aveAux = _this.processData.average(aveKnown);
      // if (!isHalfMonth) {
      //   _this[resultField].push({
      //     date: firstDay,
      //     close: null,
      //     aveKnown: aveAux,
      //     ave1: aveAux,
      //     ave2: null,
      //     id: +firstDay,
      //     contract1: "",
      //     contract2: null
      //   });
      //   firstDay = new Date(firstDay.getFullYear(), firstDay.getMonth() + 1, 1);
      // }

      _this[resultField].push({
        date: firstDay,
        close: isHalfMonth
          ? (aveKnown.length * aveAux +
              nDates2 * _this[rawField][i - 1].close +
              nDates * d.close) /
            (aveKnown.length + nDates + nDates2)
          : d.close,
        aveKnown: aveAux,
        ave1: isHalfMonth ? _this[rawField][i - 1].close : d.close,
        ave2: isHalfMonth ? d.close : null,
        n1: nDates2,
        n2: nDates,
        id: +firstDay,
        contract1: isHalfMonth
          ? _this[rawField][i - 1].contract_month_year
          : d.contract_month_year,
        contract2: isHalfMonth ? d.contract_month_year : null
      });
    } else if (d.continuous_contract > firstContract) {
      _this[resultField].push({
        date: firstDay,
        close: isHalfMonth
          ? 0.5 * d.close + 0.5 * _this[rawField][i - 1].close
          : d.close,
        id: +firstDay,
        ave1: isHalfMonth ? _this[rawField][i - 1].close : d.close,
        ave2: isHalfMonth ? d.close : null,
        contract1: isHalfMonth
          ? _this[rawField][i - 1].contract_month_year
          : d.contract_month_year,
        contract2: isHalfMonth ? d.contract_month_year : null
      });
    }
    if (d.continuous_contract >= firstContract) {
      firstDay = new Date(firstDay.getFullYear(), firstDay.getMonth() + 1, 1);
    }
  });
}

// === commodity: CPO Colombia fwd Malaysia MYR to USD
export function forwardsMYRToUSD(_this) {
  let result = [];
  let malUSDAux = _this.malaysiaUSDHistDataMonth.map(d =>
    isFinite(d.settle) && d.settle != null ? d.settle : d.close
  );
  let ave, aveAux, pushData;
  let dat = _this.malaysiaFwdData[0];
  for (let i = 0; i < _this.malaysiaFwdData.length; i++) {
    if (i === 0) {
      aveAux = (dat.ave1 * dat.n1 + dat.ave2 * dat.n2) / (dat.n1 + dat.n2);
      ave =
        (malUSDAux.length * _this.processData.average(malUSDAux) +
          ((dat.n1 + dat.n2) * aveAux) / _this.fwdUSDMYR[i].close) /
        (malUSDAux.length + dat.n1 + dat.n2);
      pushData = {
        date: _this.malaysiaFwdData[i].date,
        close: ave,
        id: +_this.malaysiaFwdData[i].date,
        contract1: _this.malaysiaFwdData[i].contract1,
        contract2: _this.malaysiaFwdData[i].contract2,
        aveKnown: aveAux / _this.fwdUSDMYR[i].curr_ave,
        ave1: _this.malaysiaFwdData[i].ave1 / _this.fwdUSDMYR[i].close,
        ave2: _this.malaysiaFwdData[i].ave2 / _this.fwdUSDMYR[i].close,
        n1: _this.malaysiaFwdData[i].n1,
        n2: _this.malaysiaFwdData[i].n2
      };
    } else {
      ave = _this.malaysiaFwdData[i].close / _this.fwdUSDMYR[i].close;
      pushData = {
        date: _this.malaysiaFwdData[i].date,
        close: ave,
        id: +_this.malaysiaFwdData[i].date,
        ave1: _this.malaysiaFwdData[i].ave1 / _this.fwdUSDMYR[i].close,
        ave2: _this.malaysiaFwdData[i].ave2 / _this.fwdUSDMYR[i].close,
        contract1: _this.malaysiaFwdData[i].contract1,
        contract2: _this.malaysiaFwdData[i].contract2,
        n2: 0
      };
    }
    result.push(pushData);
  }
  return result;
}

export function CPOColombiaFwdTooltip(
  d,
  txtTitle,
  dateFormat,
  formatNumber,
  fieldName = "PRICE"
) {
  return (
    "<table class='table table-borderless table-sm text-left table-analytics-sm'>\n" +
    "  <tbody>\n" +
    "    <tr>\n" +
    "      <td width='25%'><span class='sm-txt-mkts'>" +
    txtTitle +
    ":</span><br />" +
    timeFormat(dateFormat)(d.date) +
    "</td>\n" +
    "      <td width='18.75%'><span class='sm-txt-mkts'>" +
    fieldName +
    ":</span><br />" +
    formatNumber(d.close) +
    "</td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>"
  );
}

export function CPOColombiaFwdTooltipCurrency(
  d,
  txtTitle,
  dateFormat,
  formatNumber
) {
  return (
    "<table class='table table-borderless table-sm text-left table-markets-sm'>\n" +
    "  <tbody>\n" +
    "    <tr>\n" +
    "      <td><span class='sm-txt-mkts'>" +
    txtTitle +
    ":</span><br />" +
    timeFormat(dateFormat)(d.date) +
    "</td>\n" +
    "      <td><span class='sm-txt-mkts'>SETTLED AVE:</span><br />" +
    formatNumber(d.curr_ave) +
    "</td>\n" +
    "      <td><span class='sm-txt-mkts'>FORWARD:</span><br />" +
    formatNumber(d.curr_fwd) +
    "</td>\n" +
    "      <td><span class='sm-txt-mkts'>RATE:</span><br />" +
    formatNumber(d.close) +
    "</td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>"
  );
}

export function CPOColombiaFwdTooltipCommodity(
  d,
  txtTitle,
  dateFormat,
  formatNumber
) {
  return (
    "<table class='table table-borderless table-sm text-left table-markets-sm'>\n" +
    "  <tbody>\n" +
    "    <tr>\n" +
    "      <td><span class='sm-txt-mkts'>" +
    txtTitle +
    ":</span><br />" +
    timeFormat(dateFormat)(d.date) +
    "</td>\n" +
    "      <td><span class='sm-txt-mkts'>SETTLED AVE:</span><br />" +
    formatNumber(d.aveKnown) +
    "</td>\n" +
    "      <td><span class='sm-txt-mkts'> " +
    d.contract1.toUpperCase() +
    ":</span><br />" +
    formatNumber(d.ave1) +
    "</td>\n" +
    "      <td><span class='sm-txt-mkts'> " +
    d.contract2.toUpperCase() +
    ":</span><br />" +
    formatNumber(d.ave2) +
    "</td>\n" +
    "      <td><span class='sm-txt-mkts'>PRICE:</span><br />" +
    formatNumber(d.close) +
    "</td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>"
  );
}

export function CPOColombiaFwdTooltipCommodity2(
  d,
  txtTitle,
  dateFormat,
  formatNumber
) {
  return (
    "<table class='table table-borderless table-sm text-left table-markets-sm'>\n" +
    "  <tbody>\n" +
    "    <tr>\n" +
    "      <td><span class='sm-txt-mkts'>" +
    txtTitle +
    ":</span><br />" +
    timeFormat(dateFormat)(d.date) +
    "</td>\n" +
    "      <td><span class='sm-txt-mkts'> " +
    d.contract1.toUpperCase() +
    ":</span><br />" +
    formatNumber(d.ave1) +
    "</td>\n" +
    "      <td><span class='sm-txt-mkts'> " +
    d.contract2.toUpperCase() +
    ":</span><br />" +
    formatNumber(d.ave2) +
    "</td>\n" +
    "      <td><span class='sm-txt-mkts'>AVERAGE:</span><br />" +
    formatNumber(d.close) +
    "</td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>"
  );
}

export function CPOColombiaFwdTooltipCommodity3(
  d,
  txtTitle,
  dateFormat,
  formatNumber
) {
  return (
    "<table class='table table-borderless table-sm text-left table-analytics-sm'>\n" +
    "  <tbody>\n" +
    "    <tr>\n" +
    "      <td width='50%'><span class='sm-txt-mkts'>" +
    txtTitle +
    ":</span><br />" +
    timeFormat(dateFormat)(d.date) +
    "</td>\n" +
    "      <td width='50%'><span class='sm-txt-mkts'>AVERAGE:</span><br />" +
    formatNumber(d.ave1) +
    "</td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>"
  );
}

export function CPOColombiaComparisonHistTooltip(
  d1,
  d2,
  txtTitle,
  dateFormat,
  formatNumber,
  chartNum = 1,
  comp,
  compRott
) {
  let txt;
  if (chartNum === 1) {
    txt =
      "<table class='table table-borderless table-sm text-left table-analytics-sm'>\n" +
      "  <tbody>\n" +
      "    <tr>\n" +
      "      <td><span class='sm-txt-mkts'>" +
      txtTitle +
      ":</span><br />" +
      timeFormat(dateFormat)(d1.date) +
      "</td>\n" +
      "      <td><span class='sm-txt-mkts'>FEP:</span><br />" +
      formatNumber(d1.close) +
      "</td>\n" +
      "      <td><span class='sm-txt-mkts'>ROTT:</span><br />" +
      formatNumber(d2.close) +
      "</td>\n" +
      "      <td><span class='sm-txt-mkts'>FEP - ROTT:</span><br />" +
      formatNumber(d1.close - d2.close) +
      "</td>\n" +
      "    </tr>\n" +
      "  </tbody>\n" +
      "</table>";
  } else {
    txt =
      "<table class='table table-borderless table-sm text-left table-analytics-sm'>\n" +
      "  <tbody>\n" +
      "    <tr>\n" +
      "      <td><span class='sm-txt-mkts'>" +
      txtTitle +
      ":</span><br />" +
      timeFormat(dateFormat)(d1.date) +
      "</td>\n" +
      "      <td><span class='sm-txt-mkts'>FEP:</span><br />" +
      formatNumber(d1.close) +
      "</td>\n" +
      "      <td><span class='sm-txt-mkts'>ROTT:</span><br />" +
      formatNumber(d2.close) +
      "</td>\n" +
      "      <td><span class='sm-txt-mkts'>FEP - ROTT:</span><br />" +
      formatNumber(d1.close - d2.close) +
      "</td>\n" +
      "      <td><span class='sm-txt-mkts'>FEP NET:</span><br />" +
      formatNumber(d1.close + comp) +
      "</td>\n" +
      "      <td><span class='sm-txt-mkts'>ROTT NET:</span><br />" +
      formatNumber(d2.close + compRott) +
      "</td>\n" +
      "      <td><span class='sm-txt-mkts'>DIFFERENCE:</span><br />" +
      formatNumber(d1.close + comp - d2.close - compRott) +
      "</td>\n" +
      "    </tr>\n" +
      "  </tbody>\n" +
      "</table>";
  }
  return txt;
}

export function populateTableFEP(d, currencyFormat, dateformat) {
  // === table
  select("#fep_date").text(dateformat(d.date).toUpperCase());
  select("#fep_bmd").text(finitNum(d.bmd, currencyFormat));
  select("#fep_usdcop").text(finitNum(d.usdcop, currencyFormat));
  select("#fep_cop").text(finitNum(d.close, currencyFormat));
}

export function populateTableFEPComp(
  d,
  d2,
  currencyFormat,
  dateformat,
  comp,
  compRott
) {
  // === table
  select("#fep_date").text(dateformat(d.date).toUpperCase());
  select("#fep_bmd").text(finitNum(d.bmd, currencyFormat));
  select("#fep_usdcop").text(finitNum(d.usdcop, currencyFormat));
  select("#fep_cop").text(finitNum(d.close, currencyFormat));
  select("#fep_cop_comp").text(finitNum(d.close + comp, currencyFormat));
  select("#impo_expo_bmd").text(finitNum(d2.bmd, currencyFormat));
  select("#impo_expo_usdcop").text(finitNum(d2.usdcop, currencyFormat));
  select("#impo_expo_cop").text(finitNum(d2.close, currencyFormat));
  select("#impo_expo_cop_comp").text(
    finitNum(d2.close + compRott, currencyFormat)
  );
}

export function populateTableComparison(d, currencyFormat, dateformat) {
  // === table
  select("#compDate").text(dateformat(d.date));
  select("#compMain").text(finitNum(d.main, currencyFormat));
  select("#compSecond").text(finitNum(d.second, currencyFormat));
  select("#compSpread").text(finitNum(d.spread, currencyFormat));
  select("#compCorr").text(Math.round(100 * d.corr) / 100);
}

export function getDefaultMarketsPreferences(_this) {
  if (
    Object.keys(_this.$store.state.user_preferences.all.items.markets_choices)
      .length === 0
  ) {
    let choices = {
      selected_nav: 0,
      selected_currency: 2,
      selected_commodity: 7,
      color_theme: false,
      mmov: {
        ma1: 20,
        ma2: 40,
        rsi: 14,
        md1: 12,
        md2: 26,
        md3: 9,
        stoch1: 14,
        stoch2: 3
      },
      show20ma: true,
      show40ma: true,
      showBoll: false,
      showRSI: true,
      showMACD: false,
      showSTOCH: false,
      showFibo: false,
      showFiboR: true,
      showFiboE: false,
      showFiboTE: false,
      trendLineData: []
    };
    _this.$store.state.user_preferences.all.items.markets_choices = choices;
    saveUserPreferences(_this);
    return { choices };
  } else {
    let choices = _this.$store.state.user_preferences.all.items.markets_choices;
    return { choices };
  }
}

export function getConversions() {
  return [
    { id: 0, text: "NONE", value: 1 },
    { id: 1, text: "BRENT: USD/bbl to USD/mt", value: 7.33 },
    { id: 2, text: "BRENT: USD/mt to USD/bbl", value: 0.13642565 },
    { id: 3, text: "CANOLA OIL US: USD/st to USD/mt", value: 1.102311 },
    { id: 4, text: "CANOLA OIL US: USD/mt to USD/st", value: 0.907184996 },
    { id: 5, text: "COFFEE C: USc/lbs to USD/mt", value: 22.04623 },
    { id: 6, text: "COFFEE C: USD/mt to USc/lbs", value: 0.04536 },
    { id: 7, text: "CORN: USc/bu to USD/mt", value: 0.3936825 },
    { id: 8, text: "CORN: USD/mt to USc/bu", value: 2.54012 },
    { id: 9, text: "COTTON: USc/lbs to USD/mt", value: 22.04623 },
    { id: 10, text: "COTTON: USD/mt to USc/lbs", value: 0.04535923 },
    { id: 11, text: "CPO CIF NY: USc/lbs to USD/mt", value: 22.04623 },
    { id: 12, text: "CPO CIF NY: USD/mt to USc/lbs", value: 0.04535923 },
    { id: 13, text: "CPO: USc/lbs to USD/mt", value: 22.04623 },
    { id: 14, text: "CPO: USD/mt to USc/lbs", value: 0.04536 },
    { id: 15, text: "COPPER: USD/lbs to USD/mt", value: 2204.6 },
    { id: 16, text: "COPPER: USD/mt to USD/lbs", value: 0.00045 },
    { id: 17, text: "ETHANOL CHI: USD/gal to USD/mt", value: 334.954 },
    { id: 18, text: "ETHANOL CHI: USD/mt to USD/gal", value: 0.00298549 },
    { id: 19, text: "HEATING OIL: USD/gal to USD/mt", value: 312.9 },
    { id: 20, text: "HEATING OIL: USD/mt to USD/gal", value: 0.003195909 },
    { id: 21, text: "HRC LME EU: USD/st to USD/mt", value: 1.102311 },
    { id: 22, text: "HRC LME EU: USD/mt to USD/st", value: 0.907184996 },
    { id: 23, text: "HRC CME MIDW: USD/st to USD/mt", value: 1.102311 },
    { id: 24, text: "HRC CME MIDW: USD/mt to USD/st", value: 0.907184996 },
    { id: 25, text: "LEAN HOGS: USc/lbs to USD/mt", value: 22.04623 },
    { id: 26, text: "LEAN HOGS: USD/mt to USc/lbs", value: 0.04535923 },
    { id: 27, text: "MB PROPANE: USD/gal to USD/mt", value: 521 },
    { id: 28, text: "MB PROPANE: USD/mt to USD/gal", value: 0.001919386 },
    { id: 29, text: "MILK CLASS III: USc/lbs to USD/mt", value: 22.046 },
    { id: 30, text: "MILK CLASS III: USD/mt to USc/lbs", value: 0.0453 },
    { id: 31, text: "MILK NFD: USc/lbs to USD/mt", value: 22.046 },
    { id: 32, text: "MILK NFD: USD/mt to USc/lbs", value: 0.0453 },
    { id: 33, text: "OATS: USD/bu to USD/mt", value: 0.688944 },
    { id: 34, text: "OATS: USD/mt to USD/bu", value: 1.451497 },
    { id: 35, text: "RBOB: USD/gal to USD/mt", value: 349.86 },
    { id: 36, text: "RBOB: USD/mt to USD/gal", value: 0.0028583 },
    { id: 37, text: "RUBBER: USD/st to USD/mt", value: 1.102311 },
    { id: 38, text: "RUBBER: USD/mt to USD/st", value: 0.907184996 },
    { id: 39, text: "SOYBEAN: USc/bu to USD/mt", value: 0.367437 },
    { id: 40, text: "SOYBEAN: USD/mt to USc/bu", value: 2.72155499 },
    { id: 41, text: "SOYBEAN OIL: USc/lbs to USD/mt", value: 22.04623 },
    { id: 42, text: "SOYBEAN OIL: USD/mt to USc/lbs", value: 0.04536 },
    { id: 43, text: "SOYBEAN OIL USA: USc/lbs to USD/mt", value: 22.04623 },
    { id: 44, text: "SOYBEAN OIL USA: USD/mt to USc/lbs", value: 0.04536 },
    { id: 45, text: "SOYBEAN MEAL: USD/mt to USD/st", value: 0.907185 },
    { id: 46, text: "SOYBEAN MEAL: USD/st to USD/mt", value: 1.102311 },
    { id: 47, text: "SUGAR 11: USc/lbs to USD/mt", value: 22.04623 },
    { id: 48, text: "SUGAR 11: USD/mt to USc/lbs", value: 0.04536 },
    { id: 49, text: "WHEAT HRS: USc/bu to USD/mt", value: 0.367437 },
    { id: 50, text: "WHEAT HRS: USD/mt to USc/bu", value: 2.72155499 },
    { id: 51, text: "WHEAT HRW: USc/bu to USD/mt", value: 0.367437 },
    { id: 52, text: "WHEAT HRW: USD/mt to USc/bu", value: 2.72155499 },
    { id: 53, text: "WHEAT SRW: USc/bu to USD/mt", value: 0.367437 },
    { id: 54, text: "WHEAT SRW: USD/mt to USc/bu", value: 2.72155499 },
    { id: 55, text: "WHEAT: USD/bu to USD/mt", value: 0.367437 },
    { id: 56, text: "WHEAT: USD/mt to USD/bu", value: 2.72155 },
    { id: 57, text: "WTI: USD/bbl to USD/mt", value: 7.33 },
    { id: 58, text: "WTI: USD/mt to USD/bbl", value: 0.1364256 }
  ];
}

export function getDefaultView() {
  return {
    worldCurrencies: { value: 0, name: "Currencies", show: false },
    worldCommodities: { value: 0, name: "Commodities", show: false },
    macro: { value: 0, name: "Macro indicators", show: false },
    comparison: { value: 0, name: "Comparison", show: false },
    seasonality: { value: 0, name: "Seasonality", show: false },
    percentiles: { value: 0, name: "Percentiles", show: false },
    techAnalysis: { value: 0, name: "Technical analysis", show: true }
  };
}
